import React, { Component } from 'react';
import PropTypes from "prop-types";

import TableItem from "./item";
import EmptyTableItem from "./empty-item";

export const TableRow = ({row}) => (
    <tr>
        {row.map((col, index) => (
            col ? <TableItem key={index} data={col}/> : <EmptyTableItem key={index}/>
        ))}
    </tr>
)

TableRow.propTypes = {
    row: PropTypes.array.isRequired
}

export default TableRow;


// WEBPACK FOOTER //
// frontend/src/modules/appointment-table/row/index.jsx